import React from 'react';
import Typography500 from 'views/common/components/UI/Typography500';
import { useTranslation } from 'next-i18next';
import { Grid, Typography, Box } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StyledBox, {
  StyledAddress,
} from 'views/VehicleModelView/components/VehicleModelLocationDetails/VehicleModelLocationDetails.styles';

const VehicleModelLocationDetails = (props) => {
  const { locationInfo } = props;
  const { t } = useTranslation('fe_er_vehicle_model_page');
  return (
    <StyledBox mt={6} mb={6}>
      <Typography500 component="h2" variant="h3" mb={2} className="VMsecDark">
        {t('fe_er_vehicle_model_page:eagle_rider_location_name', {
          location_name: locationInfo.name,
        })}
      </Typography500>

      <Grid container>
        <Grid item xs={12} md={12} lg={6}>
          <StyledAddress
            location={locationInfo.name}
            addressPath={locationInfo.map_url}
            mapUrl={locationInfo.map_url}
            titlePath={locationInfo.map_url}
            details={locationInfo.full_address}
            target="_blank"
          />
        </Grid>

        <Grid item xs={12} md={12} lg={6}>
          <Grid container item spacing={2} flexWrap="nowrap">
            <Grid item className="VMLDicon">
              <AccessTimeIcon />
            </Grid>
            <Grid item>
              <Typography
                variant="body2"
                component="p"
                className="VMsecDark VMLDTitle">
                {t('fe_er_vehicle_model_page:hours_of_operation')}
              </Typography>
              <Box className="VMSDhous">
                {locationInfo.compressed_operation_hours.map((item) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Typography
                    variant="body2"
                    component="p"
                    key={`${item.to} - ${item.from}`}>
                    {`${item.days_range} ${t(
                      'fe_er_vehicle_model_page:operation_time',
                      {
                        starting_hour: item.from,
                        ending_hour: item.to,
                      },
                    )}`}
                  </Typography>
                ))}
                {locationInfo.working_hours_comment && (
                  <Typography variant="h6" component="p" className="VMSDnote">
                    <Typography500 variant="h6" component="span">
                      {t('fe_er_vehicle_model_page:note')}
                    </Typography500>

                    <Typography variant="h6" component="span">
                      {locationInfo.working_hours_comment}
                    </Typography>
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </StyledBox>
  );
};
export { VehicleModelLocationDetails };
